/**
 * Header Navigation - Active Menu Item Detection & Mobile Menu
 */

export default function initHeaderNav() {
    const headerNav = document.querySelector('.header-nav');
    if (!headerNav) return;

    // Mobile Menu Functionality
    const mobileToggle = headerNav.querySelector('.header-nav__mobile-toggle');
    const mobileOverlay = document.querySelector('.header-nav__mobile-overlay');
    const mobileClose = mobileOverlay?.querySelector('.header-nav__mobile-overlay__close');
    const mobileMenuLinks = mobileOverlay?.querySelectorAll('.header-nav__mobile-overlay__menu a');

    function openMobileMenu() {
        if (!mobileOverlay || !mobileToggle) return;
        
        mobileOverlay.setAttribute('aria-hidden', 'false');
        mobileToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        if (!mobileOverlay || !mobileToggle) return;
        
        mobileOverlay.setAttribute('aria-hidden', 'true');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    // Toggle menu on hamburger click
    if (mobileToggle && mobileOverlay) {
        mobileToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
            
            if (isOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    } else {
        console.warn('Menu mobile não encontrado:', {
            mobileToggle: !!mobileToggle,
            mobileOverlay: !!mobileOverlay
        });
    }

    // Close menu on close button click
    if (mobileClose) {
        mobileClose.addEventListener('click', function(e) {
            e.preventDefault();
            closeMobileMenu();
        });
    }

    // Close menu when clicking on a menu link
    if (mobileMenuLinks) {
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', function() {
                closeMobileMenu();
            });
        });
    }

    // Close menu when clicking outside (on overlay background)
    if (mobileOverlay) {
        mobileOverlay.addEventListener('click', function(e) {
            // Only close if clicking directly on the overlay, not on its children
            if (e.target === mobileOverlay) {
                closeMobileMenu();
            }
        });
    }

    const menuLinks = headerNav.querySelectorAll('.header-nav__menu a[href^="#"]');
    const sections = [];

    // Coletar todas as seções correspondentes aos links do menu
    menuLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href && href !== '#') {
            const section = document.querySelector(href);
            if (section) {
                sections.push({
                    link: link,
                    section: section,
                    id: href
                });
            }
        }
    });

    // Função para atualizar o item ativo do menu (apenas se houver seções)
    function updateActiveMenu() {
        const headerNavHeight = headerNav.offsetHeight;
        const headerTopHeight = document.querySelector('.header-top')?.offsetHeight || 0;
        const totalHeaderHeight = headerNavHeight + headerTopHeight;
        
        // Posição atual do scroll com um pequeno offset para detecção antecipada
        const scrollPosition = window.scrollY + totalHeaderHeight + 100;

        let currentSection = null;

        // Encontrar a seção que está atualmente cruzando o limite do scroll
        sections.forEach((item) => {
            const sectionTop = item.section.offsetTop;
            const sectionHeight = item.section.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                currentSection = item;
            }
        });

        // Caso especial: se chegarmos ao fim da página, marcar o último item
        if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 20) {
            currentSection = sections[sections.length - 1];
        }

        // Caso especial: se estivermos no topo absoluto da página
        if (window.scrollY < totalHeaderHeight) {
            currentSection = sections[0];
        }

        // Atualizar classes CSS
        menuLinks.forEach(link => {
            link.classList.remove('active');
            link.closest('li')?.classList.remove('active');
        });

        if (currentSection) {
            currentSection.link.classList.add('active');
            currentSection.link.closest('li')?.classList.add('active');
        }
    }

    // Adicionar event listeners para scroll (apenas se houver seções)
    if (sections.length > 0) {
        let scrollTimeout;
        function handleScroll() {
            if (scrollTimeout) {
                window.cancelAnimationFrame(scrollTimeout);
            }
            scrollTimeout = window.requestAnimationFrame(updateActiveMenu);
        }

        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // Atualizar na carga inicial
        updateActiveMenu();
    }

    // Adicionar funcionalidade de scroll para o topo ao clicar no logotipo
    const logo = headerNav.querySelector('.header-nav__logo');
    if (logo) {
        logo.style.cursor = 'pointer';
        logo.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            
            // Atualizar menu ativo após scroll (apenas se houver seções)
            if (sections.length > 0) {
                setTimeout(() => {
                    updateActiveMenu();
                }, 100);
            }
        });
    }

    // Modificar o comportamento dos links para scroll suave até o topo (apenas se houver seções)
    if (sections.length > 0) {
        menuLinks.forEach(link => {
            link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href && href !== '#') {
                e.preventDefault();
                
                const target = document.querySelector(href);
                if (target) {
                    const headerHeight = headerNav.offsetHeight;
                    const headerTopHeight = document.querySelector('.header-top')?.offsetHeight || 0;
                    const totalHeaderHeight = headerHeight + headerTopHeight;
                    // Usar scrollIntoView ou window.scrollTo para garantir precisão
                    const targetPosition = target.offsetTop - totalHeaderHeight;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });

                    // Forçar atualização do item ativo imediatamente para feedback instantâneo
                    // e novamente após o término do scroll
                    setTimeout(() => {
                        updateActiveMenu();
                    }, 100);
                    
                    setTimeout(() => {
                        updateActiveMenu();
                    }, 800); // Tempo médio para o scroll smooth terminar
                }
            }
        });
        });
    }
}

